import LOGO from "../../../assets/images/logo.png";
import MAP_PIN from "../../../assets/images/map-pin.png";
import MAILPNG from "../../../assets/images/mail.png";
import PHONEPNG from "../../../assets/images/phone.png";
import { Link } from "react-router";
import { useAppSelector } from "../../../app/hooks";

const Footer = () => {
  const sectors = useAppSelector((state) => state.home.sectors);
  const services = useAppSelector((state) => state.home.services);
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <a className="footer-logo">
            <img src={LOGO} alt="" style={{ width: 200 }} />
          </a>
          <a>
            <div className="social-pic">
              <img src={MAP_PIN} alt="" />
            </div>
            <div className="social-text">
              <span>Our Location</span>
              <br />
              2, Shreeji Complex, Ghodasar Highway, Ahmedabad - 380050
            </div>
          </a>
          <a href="mailto:info@bigsmileholidays.com">
            <div className="social-pic">
              <img src={MAILPNG} alt="" />
            </div>
            <div className="social-text text-underline">
              <span>Mail Us</span>
              <br />
              <strong>info@bigsmileholidays.com</strong>
            </div>
          </a>
          <a href="tel:+ 91 7600020201">
            <div className="social-pic">
              <img src={PHONEPNG} alt="phone icon" />
            </div>
            <div className="social-text">
              <span>Call</span>
              <br />
              +91 7600020201
            </div>
          </a>
        </div>
        <div className="footer-middle">
          <div className="row">
            <div className="col-md-3 col-sm-12 footmtogglep">
              <h5 className="footmtoggle">Our Products</h5>
              <ul>
                <li>
                  <a>Domestic Flights</a>
                </li>
                <li>
                  <a>International Flights</a>
                </li>
                <li>
                  <a>Corporate Flights</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-sm-12 footmtogglep">
              <h5 className="footmtoggle">About us</h5>
              <ul>
                <li>
                  <Link to={"/terms-conditions"}>Terms of Services</Link>
                </li>
                <li>
                  <a>Privacy</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-sm-12 footmtogglep">
              <h5 className="footmtoggle">Popular Destinations</h5>
              <ul>
                {sectors?.map((sector: any) => (
                  <li>
                    <Link to={`/tour/${sector?.SectorURL}/`}>
                      {sector?.SectorName}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-3 col-sm-12 footmtogglep">
              <h5 className="footmtoggle">Our Services</h5>
              <ul>
                {services?.map((service: any) => (
                  <li>
                    <Link to={`/services/${service?.URL}/`}>{service?.Title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 Big Smile Holidays. All Rights Reserved.</p>
          <a href="https://aseuminfotech.com/" target="_blank">
            Developed By ASEUM INFOTECH PVT LTD
          </a>
          {/* <a>
            <img src="./image/payment-icons.png" alt="" />
          </a> */}
        </div>
      </div>

      {/* <script src="./js/custom.js"></script>

      <script type="text/javascript">
        jQuery(document).ready(function () {
          jQuery(".select-dropdown li").click(function () {
            var droplist = jQuery(this).html();
            jQuery(this)
              .parent(".select-dropdown.showdropdown")
              .parent(".custom-select")
              .children(".select-button")
              .html(droplist);
          });
          jQuery(".select-button").click(function () {
            var droplist = jQuery(this).html();
            jQuery(this).toggleClass("active");
            jQuery(this)
              .parent(".custom-select")
              .children(".select-dropdown")
              .toggleClass("showdropdown");
          });
        });
        const customSelect = document.querySelector(".custom-select");
        const selectBtn = document.querySelector(".select-button");

        const selectedValue = document.querySelector(".selected-value");
        const optionsList = document.querySelectorAll(".select-dropdown li");
      </script> */}
    </footer>
  );
};

export default Footer;
